const ClientTransitInfoDisplayLevel = {
  NONE: "NONE",
  VALUES: "VALUES",
  VALUES_AND_FILES: "VALUES_AND_FILES",
} as const;

type ClientTransitInfoDisplayLevel =
  (typeof ClientTransitInfoDisplayLevel)[keyof typeof ClientTransitInfoDisplayLevel];

export default ClientTransitInfoDisplayLevel;
export type { ClientTransitInfoDisplayLevel };
